<template>
  <div v-if="stats">
    {{ stats.percentComplete }}% (ETA: {{ eta }})
  </div>
</template>

<script>
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import Eta from '@gofreddo/eta'

export default {
  props: ['item'],

  computed: {
    stats() {
      if (! this.item.batch) {
        return
      }

      const batch = this.item.batch

      const processedJobs = batch.total_jobs
        ? (batch.total_jobs - batch.pending_jobs)
        : 0

      const progress = new Eta({
        total: batch.total_jobs,
        count: processedJobs,
        startTime: new Date(batch.created_at),
      })

      return progress.stats()
    },

    eta() {
      const stats = this.stats

      if (! stats?.eta || ! +stats?.eta) {
        return null
      }

      return formatDistanceToNow(new Date(stats.eta))
    }
  }
}
</script>
